import routes from 'actions/routes';
import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateUpdateActionCreator } from "actions/crudActionCreators";

export default {
    assignOwners: generateUpdateActionCreator(routes.API_RECORD_ASSIGNMENT, ACTION_NAMES.ASSIGN_OWNERS),
    assignTeamsAndTerritories: generateUpdateActionCreator(routes.API_RECORD_ASSIGNMENT, ACTION_NAMES.ASSIGN_TEAMS_TERRITORIES, () => {}, () => {}, "teams_territories")
}